export const enum ProxyPortEnum {
    EalyzeProxyPort = 33_445,
    FingridProxyPort = 33_446,
    EnecoProxyPort = 33_447,
    EdprProxyPort = 33_448,
    SocoXtrProxyPort = 33_449,
    FingridSoapProxyPort = 33_450,
    ErcotProxyPort = 33_451,
    DukeEnergyProxyPort = 33_452,
    SmtProxyPort = 33_453,
}
